import { Dialog, DialogPanel } from "@headlessui/react";
import { ModalTable } from "@/components/feature/tables/deadline_tracker/modalTable";
import { PreviewInvitesModalProps } from "@/views/home/deadline_guardian/types/types";
import React from "react";

export const PreviewInvitesModal: React.FC<PreviewInvitesModalProps> = ({ isOpen, toggleModal }) => (
  <div className="bg-[#eaebe6]">
    <Dialog open={isOpen} onClose={toggleModal} className="fixed inset-0 z-50 overflow-auto">
      {/* Custom overlay using Tailwind CSS for background dimming */}
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
      <div className="flex min-h-screen items-end justify-center px-4 pb-20 pt-4 text-center sm:block sm:p-0">
        <span className="hidden sm:inline-block sm:align-middle lg:h-screen" aria-hidden="true">
          &#8203;
        </span>
        <DialogPanel className="mb-8 mt-4 inline-block transform overflow-hidden rounded-lg bg-[#eaebe6] p-6 text-left align-bottom shadow-xl transition-all">
          {/* <DialogTitle className="font-bold">Upcoming Hearings</DialogTitle>
            <Description>This table displays the upcoming hearings and parties involved.</Description> */}
          <ModalTable toggleModal={toggleModal} />
        </DialogPanel>
      </div>
    </Dialog>
  </div>
);
